import { Column } from 'react-table'
import {
  carrierAndHub,
  cmrDataTooltip,
  date,
  format,
  plannedAndActualGoodsHolderCount,
  plannedAndActualPackedQuantityForShipment,
  shipmentLink,
  shipmentStatusTooltip,
  shipToTooltip,
  UniqueTruncatedTooltip,
} from '../../../common/utils/formatter'
import { propertyAccessor } from '../../../common/components/properties/Properties'
import { RebookingIndicator, TTExceptionsIndicator } from '../ShipmentsTableIndicators'
import { Shipment } from '../../../generated/graphql'
import { getPlannedDeliveryDate, getRebookingDate } from '../detail/milestones/ShipmentMilestones'

export const shipmentsTableColumns: Column[] = [
  {
    Header: ' ',
    accessor: (shipment) => shipment,
    Cell: (shipment) => (
      <>
        <TTExceptionsIndicator ttExceptions={shipment.value.ttExceptions} />
        <RebookingIndicator rebooking={shipment.value.rebooking} />
      </>
    ),
    width: 50,
  },
  {
    Header: 'Packlist',
    accessor: 'packlistNumber',
    Cell: format(shipmentLink),
    width: 50,
  },
  {
    Header: 'Delivery Note',
    accessor: propertyAccessor('deliveries.deliveryNoteNumber'),
    Cell: format(UniqueTruncatedTooltip),
  },
  {
    Header: 'Sales Order',
    accessor: propertyAccessor('deliveries.salesOrderNumber'),
    Cell: format(UniqueTruncatedTooltip),
  },
  {
    Header: 'CMR',
    accessor: (shipment) => shipment,
    Cell: format(cmrDataTooltip),
  },
  { Header: 'Shipping Point', accessor: 'shippingPointCode' },
  {
    Header: 'Ship To',
    accessor: (shipment: Shipment) => getEnrichedShipToAddress(shipment),
    Cell: format(shipToTooltip),
  },
  {
    Header: 'Carrier & Hub',
    accessor: 'shipmentVendors[0]',
    Cell: format(carrierAndHub),
  },
  {
    Header: 'EDD',
    accessor: (shipment: Shipment) => getLatestEdd(shipment),
  },
  {
    Header: 'Shipped',
    accessor: (shipment: Shipment) => getActualShippedTimestamp(shipment),
    Cell: format(date),
  },
  { Header: 'Delivered', accessor: 'actualDeliveryDate', Cell: format(date) },
  { Header: '# Cartons (P/A)', accessor: (shipment) => plannedAndActualGoodsHolderCount(shipment) },
  {
    Header: '# Units (P/A)',
    accessor: (shipment) => plannedAndActualPackedQuantityForShipment(shipment),
  },
  {
    Header: 'Status',
    accessor: (shipment) => shipment,
    Cell: format(shipmentStatusTooltip),
  },
]

function getLatestEdd(shipment) {
  const rebookedEdd = getRebookingDate({
    shipment,
  })
  if (rebookedEdd) {
    return rebookedEdd
  } else {
    return getPlannedDeliveryDate({ shipment, dateFormat: date })
  }
}

function getEnrichedShipToAddress(shipment) {
  return {
    ...shipment.shipmentShipToAddress,
    serviceLevelCode: shipment.shipmentVendors?.[0]?.serviceLevelCode,
  }
}

function getActualShippedTimestamp(shipment) {
  return shipment.calculatedShipmentStatusCode !== 'CANCELLED'
    ? shipment.actualShippedTimestamp
    : null
}
